/**
 *
 * This file was automatically generated using build-icons npm script and should not be edited
 *
 **/
import { createIcon } from "@cmp-src/icons/create-icon";
export const NullIcon = createIcon({
  displayName: "NullIcon",
  viewBox: "0 0 16 16",
  path: (
    <g fill="none" stroke="currentColor" strokeWidth={1.5}>
      <path
        d="M3.75736 12.2426C2.67157 11.1569 2 9.65685 2 8C2 4.68629 4.68629 2 8 2C9.65685 2 11.1569 2.67157 12.2426 3.75736M3.75736 12.2426C4.84315 13.3284 6.34315 14 8 14C11.3137 14 14 11.3137 14 8C14 6.34315 13.3284 4.84315 12.2426 3.75736M3.75736 12.2426L12.2426 3.75736"
        stroke="currentColor"
        strokeWidth={1.5}
      />
    </g>
  )
});
